import { ReactCaseFlowCase } from '../react-case-flow-case';
import { CaseFlowCaseStations } from '@rabbit/bizproc/core';
import { FBD_CaseFlowPrivateProxy } from '@rabbit/data/types';

interface ClaimCheckResult {
  hasActiveClaim: boolean;
  activeClaimId?: string;
}

export async function CaseFlow_Utils_AlterCaseFacts(
  caseFlowCase: ReactCaseFlowCase,
  facts: { [key: string]: any }
) {
  await caseFlowCase?.Alter_Facts(facts);
  await caseFlowCase?.Commit();
}

export async function CaseFlow_Utils_CheckClaimExists(holdingLink: string): Promise<ClaimCheckResult>{
  // Let's check if the case already exists for holdingLink
  const caseProxyQuery = FBD_CaseFlowPrivateProxy.query().where(
    'facts.consumer_holding',
    '==',
    holdingLink
  ).where('case_state', '!=', CaseFlowCaseStations.ARCHIVED);
  
  const caseProxyContents = await caseProxyQuery.getContents();
  if (!caseProxyContents || caseProxyContents.length === 0) {
    return { hasActiveClaim: false };
  }
  const caseProxyData = caseProxyContents[0];
  return { 
    hasActiveClaim: true,
    activeClaimId: caseProxyData.docid.split('_')[0]
  }
}
